import { Topbar } from "../components/Topbar";
import { KpiCard } from "../components/KpiCard";
import { Panel } from "../components/Panel";
import { DataTable } from "../components/DataTable";
import { LoadingState, ErrorState } from "../components/States";
import { useDashboard } from "../hooks/useDashboard";
import { formatCurrency, formatHours, formatNumber, formatPct } from "../lib/dates";

export default function Analytic() {
  const { data, loading, error } = useDashboard("analytic");

  return (
    <>
      <Topbar title="Contabilidad analítica" subtitle="Márgenes por cuenta analítica" />
      <div className="p-6 space-y-6" data-testid="analytic-page">
        {loading && <LoadingState />}
        {error && <ErrorState message={error} />}
        {data && (
          <>
            <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
              <KpiCard testId="kpi-ana-income" label="Ingreso" value={formatCurrency(data.kpis.total_income)} />
              <KpiCard testId="kpi-ana-cost" label="Coste" value={formatCurrency(data.kpis.total_cost)} />
              <KpiCard testId="kpi-ana-margin" label="Margen" value={formatCurrency(data.kpis.total_margin)} accent={data.kpis.total_margin >= 0 ? "success" : "danger"} />
              <KpiCard testId="kpi-ana-margin-pct" label="Margen %" value={formatPct(data.kpis.avg_margin_pct)} accent={data.kpis.avg_margin_pct >= 0 ? "success" : "danger"} />
              <KpiCard testId="kpi-ana-hours" label="Horas" value={formatHours(data.kpis.total_hours)} />
              <KpiCard testId="kpi-ana-accounts" label="Cuentas activas" value={formatNumber(data.kpis.accounts_count, { maximumFractionDigits: 0 })} />
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              <Panel title="Top margen positivo" subtitle="Cuentas más rentables" testId="table-top-margin">
                <DataTable
                  testId="top-margin-table"
                  filename="top_margen_positivo.csv"
                  rows={data.top_margin}
                  columns={[
                    { key: "account", label: "Cuenta", accessor: "account" },
                    { key: "income", label: "Ingreso", accessor: "income", render: (r) => formatCurrency(r.income) },
                    { key: "cost", label: "Coste", accessor: "cost", render: (r) => formatCurrency(r.cost) },
                    {
                      key: "margin", label: "Margen", accessor: "margin",
                      render: (r) => <span className="text-emerald-600 font-medium tabular-nums">{formatCurrency(r.margin)}</span>,
                    },
                    { key: "margin_pct", label: "%", accessor: "margin_pct", render: (r) => formatPct(r.margin_pct) },
                  ]}
                />
              </Panel>

              <Panel title="Top margen negativo" subtitle="Cuentas con mayor pérdida" testId="table-bottom-margin">
                <DataTable
                  testId="bottom-margin-table"
                  filename="top_margen_negativo.csv"
                  rows={data.bottom_margin}
                  columns={[
                    { key: "account", label: "Cuenta", accessor: "account" },
                    { key: "income", label: "Ingreso", accessor: "income", render: (r) => formatCurrency(r.income) },
                    { key: "cost", label: "Coste", accessor: "cost", render: (r) => formatCurrency(r.cost) },
                    {
                      key: "margin", label: "Margen", accessor: "margin",
                      render: (r) => <span className="text-red-600 font-medium tabular-nums">{formatCurrency(r.margin)}</span>,
                    },
                    { key: "margin_pct", label: "%", accessor: "margin_pct", render: (r) => formatPct(r.margin_pct) },
                  ]}
                />
              </Panel>
            </div>

            <Panel title="Todas las cuentas analíticas" subtitle="Primeras 100 por margen" testId="table-all-analytic">
              <DataTable
                testId="analytic-table"
                filename="cuentas_analiticas.csv"
                rows={data.accounts}
                columns={[
                  { key: "account", label: "Cuenta", accessor: "account" },
                  { key: "income", label: "Ingreso", accessor: "income", render: (r) => formatCurrency(r.income) },
                  { key: "cost", label: "Coste", accessor: "cost", render: (r) => formatCurrency(r.cost) },
                  {
                    key: "margin", label: "Margen", accessor: "margin",
                    render: (r) => (
                      <span className={`tabular-nums font-medium ${r.margin >= 0 ? "text-emerald-600" : "text-red-600"}`}>
                        {formatCurrency(r.margin)}
                      </span>
                    ),
                  },
                  { key: "margin_pct", label: "%", accessor: "margin_pct", render: (r) => formatPct(r.margin_pct) },
                  { key: "hours", label: "Horas", accessor: "hours", render: (r) => formatHours(r.hours) },
                ]}
              />
            </Panel>
          </>
        )}
      </div>
    </>
  );
}
